<script setup lang="ts">
const props = defineProps<{
  resource: string
  amount?: number
  dice?: string | null
  label?: string
}>()

const mods = useMods()

const emit = (ev: MouseEvent) => {
  if (props.resource) {
    const amount = props.amount || 1
    const event = new CustomEvent('UseResource', {
      detail: {
        name: props.resource,
        amount: ev.shiftKey ? -amount : amount,
      },
    })
    document.body.dispatchEvent(event)
  }

  if (props.dice && !ev.shiftKey) {
    const event = new CustomEvent('rollDice', {
      detail: { dice: props.dice, variables: mods(), label: props.label },
    })
    document.body.dispatchEvent(event)
  }
}
</script>

<template>
  <button class="use-resource" @click="emit($event)">
    <slot></slot>
  </button>
</template>

<style lang="postcss">
.use-resource {
  margin: 0;
  padding: 0 0.5em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5ch;
}
</style>
